import client from "./base";
import { LpFilter, LpWhere } from "../models/lp-filter";
import { DistributorInventoryModel, ICreateOrderPayload } from "../models";
import { IPharmacyOrder } from "../models/pharmacy-order";

const getDistributorInventories = async (filter: LpFilter, adminId?: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/${adminId ? 'admin-' : ''}distributor-inventories?filter=${JSON.stringify(filter)}`

    return client.get<DistributorInventoryModel[]>(path).then(res => res.data)
}

const getDistributorInventoriesDetail = async (distributorInventoryId: number, adminId?: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/${adminId ? 'admin-' : ''}distributor-inventories/${distributorInventoryId}`

    return client.get<DistributorInventoryModel>(path).then(res => res.data)
}

const getDistributorInventoriesCount = async (where: LpWhere, adminId?: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/${adminId ? 'admin-' : ''}distributor-inventories/count?where=${JSON.stringify(where)}`

    return client.get<{ count: number }>(path).then(res => res.data?.count)
}

const getDetailDistributorInventory = async (inventoryId: number, adminId?: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/${adminId ? 'admin-' : ''}distributor-inventories/${inventoryId}`

    return client.get<DistributorInventoryModel>(path).then(res => res.data)
}

const createOrder = async (payload: ICreateOrderPayload) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/pharmacy-orders`

    return client.post(path, payload).then(res => res.data)
}

const editOrder = async (orderId: number, payload: ICreateOrderPayload) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/pharmacy-orders/${orderId}`

    return client.patch(path, payload)
}

const getPharmacyOrder = async (filter: LpFilter) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/pharmacy-orders?filter=${JSON.stringify(filter)}`

    return client.get<IPharmacyOrder[]>(path).then(res => res.data)
}

const getPharmacyOrderDetail = async (orderId: number, filter: LpFilter) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/pharmacy-orders/${orderId}?filter=${JSON.stringify(filter)}`

    return client.get<IPharmacyOrder>(path).then(res => res.data)
}

const getPharmacyOrderCount = async (where: LpWhere) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/pharmacy-orders/count?where=${JSON.stringify(where)}`

    return client.get<{ count: number }>(path).then(res => res.data.count)
}

export interface ProductDistributor {
    mId: number;
    mName: string;
    mStatus: string;
    mCreated: string;
    mModified: string;
}

const getProductDistributors = async () => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/admins/product-distributors`

    return client.get<ProductDistributor[]>(path).then(res => res.data)
}

const distributorApi = {
    getDistributorInventories,
    getDistributorInventoriesDetail,
    getDetailDistributorInventory,
    getDistributorInventoriesCount,
    createOrder,
    getPharmacyOrder,
    getPharmacyOrderCount,
    getPharmacyOrderDetail,
    editOrder,
    getProductDistributors,
}

export default distributorApi